const COUNT_FORMATS = [
  { // 0 - 999
    letter: '',
    limit: 1e3,
  },
  { // 1,000 - 999,999
    letter: 'K',
    limit: 1e6,
  },
  { // 1,000,000 - 999,999,999
    letter: 'M',
    limit: 1e9,
  },
  { // 1,000,000,000 - 999,999,999,999
    letter: 'B',
    limit: 1e12,
  },
  { // 1,000,000,000,000 - 999,999,999,999,999
    letter: 'T',
    limit: 1e15,
  },
];

// Format Method:
// eslint-disable-next-line import/prefer-default-export
export function formatCount(value) {
  let safeValue = value;
  const format = COUNT_FORMATS.find(f => (safeValue < f.limit));

  safeValue = (1000 * safeValue / format.limit);
  safeValue = Math.round(safeValue * 10) / 10; // keep one decimal number, only if needed

  return `${safeValue} ${format.letter}`;
}
